import { Grid } from '@material-ui/core';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import { requiredDropdown } from 'helpers/ValidationHelpers';
import _ from 'lodash';
import React from 'react';
import store from 'store';
import { FullField } from 'components/CustomFields/CustomFields.jsx';

class Momentum extends React.Component {
	isMultiplyMember() {
		const multiplyMembership = _.get(
			store.getState().form.quotev2,
			'values.multiplyMembership',
			null
		);

		return multiplyMembership
			? multiplyMembership === '2' || multiplyMembership === '3'
			: false;
	}

	multiplyMemberValidate = value => {
		return !this.isMultiplyMember() ? undefined : requiredDropdown(value);
	};

	heartScoreValidate = value => {
		return !this.isMultiplyMember() ? undefined : requiredDropdown(value);
	};

	render() {
		const multiplyMember = this.isMultiplyMember();
		return (
			<Grid container>
				<FullField
					name={'momentumInteractive'}
					label={'Momentum interactive *'}
					component={FormDropdown}
					checkValidation={this.props.checkValidation}
					isrequired={true}
					validate={[requiredDropdown]}
					options={[
						{ value: 'validationError', displayValue: 'Please select' },
						{ value: 'A', displayValue: 'Yes' },
						{ value: 'N', displayValue: 'No' }
					]}
				/>
				<FullField
					name={'multiplyMembership'}
					label={'Multiply membership *'}
					component={FormDropdown}
					checkValidation={this.props.checkValidation}
					isrequired={true}
					validate={[requiredDropdown]}
					onChange={() => this.props.forceUpdate()}
					options={[
						{ value: 'validationError', displayValue: 'Please select' },
						{ value: '1', displayValue: 'Not a Multiply member' },
						{ value: '2', displayValue: 'Current Multiply member' },
						{ value: '3', displayValue: 'New application - main member' }
					]}
				/>
				{!multiplyMember ? null : (
					<FullField
						name={'multiplyStatus'}
						label={'Multiply member status *'}
						component={FormDropdown}
						checkValidation={this.props.checkValidation}
						isrequired={true}
						validate={[this.multiplyMemberValidate]}
						options={[
							{ value: 'validationError', displayValue: 'Please select' },
							{ value: 'B', displayValue: 'Bronze' },
							{ value: 'G', displayValue: 'Gold' },
							{ value: 'P', displayValue: 'Platinum' },
							{ value: 'C', displayValue: 'Private Club' },
							{ value: 'S', displayValue: 'Silver' }
						]}
					/>
				)}

				<FullField
					name={'MSTIDriver'}
					label={'MSTI Driver *'}
					component={FormDropdown}
					checkValidation={this.props.checkValidation}
					isrequired={true}
					validate={[requiredDropdown]}
					options={[
						{ value: 'validationError', displayValue: 'Please select' },
						{ value: 'N', displayValue: 'No' },
						{ value: 'Y', displayValue: 'Yes' }
					]}
				/>

				{!multiplyMember ? null : (
					<FullField
						name={'heartScore'}
						label={'Healthy heart score *'}
						component={FormDropdown}
						checkValidation={this.props.checkValidation}
						isrequired={true}
						validate={[this.heartScoreValidate]}
						options={[
							{ value: 'validationError', displayValue: 'Please select' },
							{ value: 'N', displayValue: 'None' },
							{ value: 'R', displayValue: 'Red' },
							{ value: 'A', displayValue: 'Amber' },
							{ value: 'G', displayValue: 'Green' }
						]}
					/>
				)}
			</Grid>
		);
	}
}

export default Momentum;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/CompanySpecificQuestions/momentum.jsx